import React from "react";
import classes from "./StakingCardStyles.module.scss";
import { ActionButton } from "../Buttons/ActionButton/ActionButton";
import { Trans } from "@lingui/macro";
import { isUndefined, isNull } from "lodash";


type Props = {
  symbol: string;
  title: string;
  icon: string;
  infoicon: string;
  apr: JSX.Element;
  info: JSX.Element;
  rewardsUsd?: string;
  multiplierPointsAPR?: JSX.Element;
  boostPercentage?: string;
  walletBalance: string;
  staked: string;
  stakedInUsd: string;
  onStakeClick?: () => void | null;
  onUnStakeClick?: () => void | null;
  onStakeCLPClick?: () => void | null;
  onUnStakeCLPClick?: () => void | null;
  onBuyClick?: () => void;
  onSellClick?: () => void;
  onInsuranceClick?: () => void;
  connectWallet: () => void;
  isAuthorized?: boolean;
};
export const StakingCard = ({
  staked,
  title,
  stakedInUsd,
  symbol,
  apr,
  info,
  onStakeClick,
  onUnStakeClick,
  onStakeCLPClick,
  onUnStakeCLPClick,
  // rewards,
  onBuyClick,
  walletBalance,
  multiplierPointsAPR,
  boostPercentage,
  icon,
  infoicon,
  rewardsUsd,
  onSellClick,
  onInsuranceClick,
  isAuthorized,
  connectWallet,
}: Props) => {
  const stakedAndRewardsTooLong = Boolean((staked && staked.length > 6) || (rewardsUsd && rewardsUsd.length > 6));
  
  function titleShouldBeUnderlined(symbol) {
    // Define titles that should be underlined
    const titlesToUnderline = ["EsCAD", 'CLP']; // Replace with your actual titles
    return titlesToUnderline.includes(symbol);
  }
  
  return (
    <div className={classes.component}>
      <div className={classes.header}>
        <div className={classes.titleWrapper}>
          <img src={icon} width={36} height={36} alt="" className="" />
          <div className={classes.titleContent}>
            <span className={`${classes.symbol} ${titleShouldBeUnderlined(symbol) ? classes.underlinedtitle : ''}`}>
              {title}
            </span>
            {/* <img src={infoicon} width={20} height={20} alt="" className="" title="Hello"/>  */}
            <span className={classes.stats}>
              APR: <span className={classes.aprValue}>{apr}</span>
            </span>
          </div>
        </div>
        <div className={classes.balanceWrapper}>
          <span className={classes.balance}>
            <span className={classes.wallet}>Wallet:</span> {walletBalance} {symbol}
          </span>
          {onBuyClick && (
            <ActionButton
              className={classes.smallButton}
              onClick={onBuyClick}
              type={"black"}
              buttonText={
                <>
                  <Trans>Buy</Trans>
                </>
              }
            />
          )}
          {onSellClick && (
            <ActionButton
              className={classes.smallButton}
              onClick={onSellClick}
              type={"black"}
              buttonText={
                <>
                  <Trans>Sell</Trans>
                </>
              }
            />
          )}
        </div>
      </div>
      <div className={classes.main}>
        {(multiplierPointsAPR || boostPercentage) && (
          <div className={classes.features}>
            {multiplierPointsAPR && (
              <span className={classes.featureItem}>
                <Trans>Multiplier Points APR</Trans>: {multiplierPointsAPR}
              </span>
            )}
            {boostPercentage && (
              <span className={classes.featureItem}>
                <Trans>Boost Percentage</Trans>: {boostPercentage}
              </span>
            )}
          </div>
        )}
        <div className={classes.contentWrapper}>
          <div className={classes.balances}>
            <div className={classes.balanceItemWrapper}>
              <span className={classes.title}>
                <Trans>Staked</Trans>
              </span>
              <span style={stakedAndRewardsTooLong ? { fontSize: 25 } : {}} className={classes.coinBalance}>
                {staked} <span className={classes.coinBalanceSymbol}>{symbol}</span>
              </span>
              <span className={classes.usdBalance}>$ {stakedInUsd}</span>
            </div>
            {!isUndefined(rewardsUsd) && (
              <div className={classes.balanceItemWrapper}>
                <span className={classes.title}>
                  <Trans>Rewards</Trans>
                </span>
                {/*<span className={classes.coinBalance}>{rewards}</span>*/}
                <span style={stakedAndRewardsTooLong ? { fontSize: 25 } : {}} className={classes.coinBalance}>
                  {rewardsUsd} <span className={classes.coinBalanceSymbol}>$</span>
                </span>
              </div>
            )}
          </div>
          <div className={classes.buttonsWrapper}>
            {onInsuranceClick && (
              <ActionButton
                className={classes.compoundStyles}
                onClick={isAuthorized ? onInsuranceClick : connectWallet}
                type={"outlined"}
                buttonText={<Trans>Purchase Insurance</Trans>}
              />
            )}

            {!isNull(onStakeClick) && (
              <ActionButton
                className={classes.compoundStyles}
                onClick={isAuthorized && onStakeClick ? onStakeClick : connectWallet}
                type={"outlined"}
                buttonText={Number(staked) > 0 ? <Trans>Stake more</Trans> : <Trans>Stake</Trans>}
              />
            )}
            {!isNull(onUnStakeClick) && (
              <ActionButton
                onClick={isAuthorized && onUnStakeClick ? onUnStakeClick : connectWallet}
                type={"grey"}
                buttonText={<Trans>Unstake</Trans>}
              />
            )}
            {/* {!isNull(onStakeCLPClick) && (
              <ActionButton
              onClick={isAuthorized && onUnStakeCLPClick ? onUnStakeCLPClick : connectWallet}
              type={"grey"}
              buttonText={<Trans>Withdraw</Trans>}
              />
            )} */}
            {!isNull(onUnStakeCLPClick) && (
              <ActionButton
                onClick={isAuthorized && onUnStakeCLPClick ? onUnStakeCLPClick : connectWallet}
                type={"grey"}
                buttonText={<Trans>Withdraw</Trans>}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
